import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import useEventListener from '@propertypal/shared/src/hooks/useEventListener';
import { Property } from '@propertypal/shared/src/types/property';
import React, { FunctionComponent, useState, useLayoutEffect, useRef } from 'react';
import config from '../../../../app.config.json';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Container } from './PdfDropdown.style';

interface Props {
  property: Property;
}

const MEDIA_SERVER =
  config.env === 'Develop' ? 'https://public-media-api-dev-v4ua7muuea-nw.a.run.app' : 'https://media.propertypal.com';

const PdfDropdown: FunctionComponent<Props> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [align, setAlign] = useState<'left' | 'right'>('right');
  const [showPdfDropDown, setShowPdfDropDown] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // @ts-ignore
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setShowPdfDropDown(false);
    }
  };

  const handleOpenPdf = () => {
    if (props.property.brochures?.length) {
      if (props.property.brochures.length > 1) {
        setShowPdfDropDown(!showPdfDropDown);
      } else {
        window.open(props.property.brochures[0].url);
      }
    }
  };

  useEventListener('click', handleClick);

  useLayoutEffect(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      // Calculate if the center of the component is on the left half of the screen
      const isLeftSide = rect.left + rect.width / 2 < viewportWidth / 2;

      setAlign(isLeftSide ? 'left' : 'right');
    }
  }, [showPdfDropDown]);

  if (!props.property.brochures) {
    return null;
  }

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <button type="button" onClick={handleOpenPdf}>
        <FontAwesomeIcon icon={faDownload} size={20} />
        Brochure
      </button>

      {showPdfDropDown && (
        <Container $align={align}>
          {props.property.brochures.map((brochure) => (
            <a key={brochure.url} href={brochure.url} download={brochure.title} type="button">
              {brochure.title} ({brochure.sizeDescription})
            </a>
          ))}

          {props.property.brochures.length > 1 && (
            <a href={`${MEDIA_SERVER}/f/${props.property.type === 'development' ? 'd' : 'p'}/${props.property.id}`}>
              Download All
            </a>
          )}
        </Container>
      )}
    </div>
  );
};

export default PdfDropdown;
